module.exports = __webpack_public_path__ + "static/media/you-match.fb5731c9.png";